import React, { memo } from 'react'
import { RadioButtonType } from '../../libraries/RadioButtonTheme'
import { TooltipPositionTypes } from '../../libraries/Tooltips'
import { getMergedClassNames } from '../../utils/HTMLutils'
import { RADIO_BUTTON_NEW } from '../../libraries/RadioButtonTheme'
import './RadioButton.scss'
const rootClassName = 'component-radio-button'

interface RadioButtonProps {
  'tooltip-position'?: TooltipPositionTypes
  'tooltip-text'?: string
  disabled?: boolean
  value: boolean
  theme?: RadioButtonType
  onChange: (value: boolean) => void
}

function RadioButton(props: RadioButtonProps) {
  const handleClick = () => {
    if (!props.disabled) {
      props.onChange(!props.value)
    }
  }

  const getProps = () => {
    const p: any = {
      ...props,
      className: getMergedClassNames([
        rootClassName,
        props.theme,
        `${rootClassName}-${props.value ? 'checked' : 'not'}`
      ]),
      onClick: handleClick
    }
    delete p.value
    delete p.onChange
    return p
  }

  return <button {...getProps()} />
}

RadioButton.defaultProps = {
  disabled: false,
  value: false,
  onChange: () => {},
  theme: RADIO_BUTTON_NEW
}

export default memo(RadioButton)
